import React from "react"
import TuscanyWeddingPage from "../../templates/hotels/TuscanyWeddingPage"

const Page = () => <TuscanyWeddingPage locale="fr" />

export default Page
